import styled from 'styled-components';

import { DOCKED_PANEL_OFFSET_VAR } from '@makemydeal/dr-activities-recent-deals';

export const RecentDealsLayoutContent = styled.div<{ $docked: boolean }>`
    display: ${({ $docked }) => ($docked ? 'block' : 'contents')};
    margin-left: var(${DOCKED_PANEL_OFFSET_VAR}, 0);
`;
